import PropTypes from 'prop-types';

const phrasesType = PropTypes.objectOf(
  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
);

export default phrasesType;
